//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const classQuizzesInitial = [];

export const classQuizzes = (state = classQuizzesInitial, action) => {
    switch (action.type) {
        case ActionTypes.classQuizzes.updateClassQuizById:
            return state.map(x => {
                if (x.id === action.payload.id) {
                    return { ...x, ...action.payload };
                } else {
                    return x;
                }
            });
        case ActionTypes.classQuizzes.listClassQuizzesSuccess:
            return action.payload;
        case ActionTypes.classQuizzes.createClassQuizSuccess:
            return [action.payload, ...state];
        case ActionTypes.classQuizzes.deleteClassQuizSuccess:
            return state.filter(x => x.id !== action.payload.id && x.quizId !== action.payload.id);
        case ActionTypes.classQuizzes.deleteMultiClassQuizSuccess:
            const { id, classIds, checkClassId } = action.payload;
            if(checkClassId){
                return state.filter(x => x.id !== id && x.quizId !== id);
            }
            return state.map(item => {
                if (item.id === id || item.quizId === id) {
                    return { ...item, classes: item.classes.filter(c => !classIds.includes(c.id)) };
                }
                return item;
            });
        case ActionTypes.classQuizzes.updateClassQuizSuccess:
            return state.map(x => {
                if (x.id === action.payload.id) {
                    return { ...x, ...action.payload };
                } else {
                    return x;
                }
            });
        case ActionTypes.classQuizzes.updateClassQuizzesFromSchoologySocket: {
            const { assignments, currentClassId } = action.payload;
            if (!assignments?.length || !currentClassId) return state;
            const idsToMerge = new Map();
            assignments.forEach((item) => {
                if (item.classId !== currentClassId || !item.quizId || !item.updatedData?.id) return;
                const u = item.updatedData;
                idsToMerge.set(u.id, {
                    id: u.id,
                    sAssignmentId: u.sAssignmentId,
                    deleted_from_integration: u.deleted_from_integration,
                    queue_status: u.queue_status,
                    grade_type: u.grade_type,
                    weightage: u.weightage,
                    max_point: u.max_point
                });
            });
            if (idsToMerge.size === 0) return state;
            return state.map(x => {
                const merge = idsToMerge.get(x.id);
                return merge ? { ...x, ...merge } : x;
            });
        }
        case ActionTypes.classQuizzes.listClassQuizzesForStudentWithIds:
            if(action.payload?.isDeleted){
                const { activityIds } = action.payload;
                if(activityIds?.length > 0){
                    return state.filter(data => !activityIds.includes(data?.quizId));
                }
                return state;
            }
            const haveSome = state.some(data => data?.id === action.payload?.id);
            if(haveSome){
                return state.map(data => {
                    if(data?.id === action.payload?.id){
                        return action.payload;
                    }
                    return data;
                });
            }else{
                const newData = [...state, action.payload];
                return newData;
            }
        case ActionTypes.classQuizzes.listClassQuizzesFail:
        case ActionTypes.classQuizzes.createClassQuizFail:
        case ActionTypes.classQuizzes.deleteClassQuizFail:
        case ActionTypes.classQuizzes.uodateClassQuizFail:
        default:
            return state;
    }
};
